export type Point = { x: number; y: number };

/**
 * Returns the subject's lateral side from an observer looking toward lookAt.
 * Browser/SVG coordinates increase downward on the y-axis, so a negative
 * 2-D cross product is visually LEFT and a positive value is visually RIGHT.
 */
export function sideFromView(
  origin: Point,
  lookAt: Point,
  subject: Point,
): "LEFT" | "RIGHT" {
  const forwardX = lookAt.x - origin.x;
  const forwardY = lookAt.y - origin.y;
  const subjectX = subject.x - origin.x;
  const subjectY = subject.y - origin.y;
  const cross = forwardX * subjectY - forwardY * subjectX;
  return cross < 0 ? "LEFT" : "RIGHT";
}
